import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSellWithNoCard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11 10L11 19",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 10H8C6.89543 10 6 10.8954 6 12V17C6 18.1046 6.89543 19 8 19H18C19.1046 19 20 18.1046 20 17V16.5C20 16.2239 19.7761 16 19.5 16C19.303 16 19.108 15.9612 18.926 15.8858C18.744 15.8104 18.5786 15.6999 18.4393 15.5607C18.3001 15.4214 18.1896 15.256 18.1142 15.074C18.0388 14.892 18 14.697 18 14.5C18 14.303 18.0388 14.108 18.1142 13.926C18.1896 13.744 18.3001 13.5786 18.4393 13.4393C18.5786 13.3001 18.744 13.1896 18.926 13.1142C19.108 13.0388 19.303 13 19.5 13C19.7761 13 20 12.7761 20 12.5V12C20 10.8954 19.1046 10 18 10Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.46508 13.0912L2.51764 9.55532C2.23176 8.48839 2.86493 7.39171 3.93186 7.10583L13.5911 4.51764C14.658 4.23175 15.7547 4.86492 16.0406 5.93185L16.4855 7.59204",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSellWithNoCard);
export default ForwardRef;
